import axios from 'axios';

const firePixelBlueKeel = async(hsid) => {
	let link = 'https://www.bkoffers.com/hitstreet/pixel_fire_dynamic_new2.cfm?hsid=' + hsid;
	try {
		await axios({
			method: 'GET',
			headers: {
                'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			url: link
		});
		console.log('BK pixel fired for hsid: ', hsid);
		return;
	} catch(err) {
		console.log('Failed to fire BK convrsion:', err.message);
		return;
	}
};

export default firePixelBlueKeel;